import styled from 'styled-components';
import { Typography } from 'components/generic/typography';
import type { ContentCardProps } from '../types';
import format from 'helpers/translations';

const Subheading = styled(Typography.Body)`
    color: ${({ theme }) => theme.ColorTextSecondary};
`;

const Heading = styled(Typography.Headline)`
    color: ${({ theme }) => theme.ColorTextPrimary};
`;

const ChildrenContainer = styled.div`
    color: ${({ theme }) => theme.ColorTextPrimary};
    margin-top: ${({ theme }) => theme.Spacing4};
`;

function ContentCardLayout({
    subheading,
    heading,
    children
}: Pick<ContentCardProps, 'subheading' | 'heading'> & { children?: React.ReactNode }) {
    return (
        <>
            <Subheading forwardedAs="div" size="M">
                {subheading}
            </Subheading>
            <Heading forwardedAs="h3" size="S">
                {format(heading)}
            </Heading>
            {children && <ChildrenContainer>{children}</ChildrenContainer>}
        </>
    );
}

export default ContentCardLayout;
